export var DatePickerError;
(function (DatePickerError) {
    DatePickerError["INVALID_DATE"] = "INVALID_DATE";
    DatePickerError["BEFORE_MIN_DATE"] = "BEFORE_MIN_DATE";
    DatePickerError["AFTER_MAX_DATE"] = "AFTER_MAX_DATE";
    DatePickerError["PAST_NOT_ALLOWED"] = "PAST_NOT_ALLOWED";
    DatePickerError["FUTURE_NOT_ALLOWED"] = "FUTURE_NOT_ALLOWED";
    DatePickerError["WEEKEND_NOT_ALLOWED"] = "WEEKEND_NOT_ALLOWED";
    DatePickerError["DISABLED_DATE"] = "DISABLED_DATE";
})(DatePickerError || (DatePickerError = {}));
//# sourceMappingURL=DatePickerError.js.map